import React from "react";

/**
 * Stat card — mini KPI tile.
 *   <StatsCard label="Pending" value={12} tone="amber" />
 */
const toneMap = {
  emerald: "text-emerald-700 bg-emerald-50",
  amber:   "text-amber-700 bg-amber-50",
  sky:     "text-sky-700 bg-sky-50",
  violet:  "text-violet-700 bg-violet-50",
  slate:   "text-slate-700 bg-slate-50",
  rose:    "text-rose-700 bg-rose-50",
};

export function StatsCard({ label, value, tone = "slate", Icon, testid }) {
  const t = toneMap[tone] || toneMap.slate;
  return (
    <div
      data-testid={testid || `stat-${label?.toLowerCase()}`}
      className={`rounded-2xl p-3.5 ${t.split(" ")[1]} border border-transparent hover:border-slate-200 transition`}
    >
      <div className="flex items-center justify-between">
        {Icon && <Icon className={`w-4 h-4 ${t.split(" ")[0]}`} strokeWidth={2.4} />}
        <div className={`text-[10px] uppercase tracking-wider font-bold ${t.split(" ")[0]}`}>{label}</div>
      </div>
      <div className={`text-2xl font-bold mt-2 ${t.split(" ")[0]} leading-none`}>{value}</div>
    </div>
  );
}
